/**
 * Admin Portal LaTeX Utilities
 *
 * This file re-exports from the shared UI library for consistency
 * across all BayesPrep portals.
 */

// Re-export everything from the shared library
export * from '@bayesprep/shared-ui/katex';

// For backward compatibility, also export with TypeScript types
import type { ReactNode } from 'react';
import {
  renderLatex as sharedRenderLatex,
  hasLatex as sharedHasLatex,
  renderLatexForTable as sharedRenderLatexForTable
} from '@bayesprep/shared-ui/katex';

// Type-safe wrappers for TypeScript
export const renderLatex = (text: string): ReactNode => sharedRenderLatex(text);
export const hasLatex = (text: string): boolean => sharedHasLatex(text);
export const renderLatexForTable = (text: string, maxLength?: number): ReactNode => sharedRenderLatexForTable(text, maxLength);
